export const DEFAULT_PAGE_SIZE = 10;
export const API_KEY_ACTION_TYPE = {
    REVOKE: 'revoke',
    RESTORE: 'restore'
}

export const API_DOCS_URL = 'https://docs.google.com/document/d/1DlUp8L-FRehQHEhs5WxSf0YKsx67UQmtFwGXvYflwSk/edit?tab=t.0#heading=h.ne24axbfyzdh';
